import { render, staticRenderFns } from "./ModalCustomDomainInstructions.vue?vue&type=template&id=cfe944a4&scoped=true"
import script from "./ModalCustomDomainInstructions.vue?vue&type=script&lang=js"
export * from "./ModalCustomDomainInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe944a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfe944a4')) {
      api.createRecord('cfe944a4', component.options)
    } else {
      api.reload('cfe944a4', component.options)
    }
    module.hot.accept("./ModalCustomDomainInstructions.vue?vue&type=template&id=cfe944a4&scoped=true", function () {
      api.rerender('cfe944a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalCustomDomainInstructions.vue"
export default component.exports